import { render, staticRenderFns } from "./createExtraPackaging.vue?vue&type=template&id=24829703&"
import script from "./createExtraPackaging.vue?vue&type=script&lang=js&"
export * from "./createExtraPackaging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports